module.exports = __webpack_public_path__ + "img/Wisdom@2x.716d9e82.png";